// extracted by mini-css-extract-plugin
module.exports = {"off-grid-O":"O_off-grid-O__YoG11"};